export default "__VITE_ASSET__CtmlkGxh__"